import DynamicPage from 'components/DynamicPage';

const Support = () => {
  return(
    <DynamicPage url="/outsyde-support" />
  )
}

export default Support;
